import { render, staticRenderFns } from "./modal-header-slot.mpx?vue&type=template&id=4c48dffc&isComponent&outputPath=components%2Fmodal-header-slot07fcc527%2Findex"
import script from "./modal-header-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-header-slot07fcc527%2Findex"
export * from "./modal-header-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-header-slot07fcc527%2Findex"
import style0 from "./modal-header-slot.mpx?vue&type=style&index=0&id=4c48dffc&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_07fcc527%22%7D&isComponent&outputPath=components%2Fmodal-header-slot07fcc527%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports